import React, { useEffect, useState } from 'react'
import { getLookupItemByCodeOrNew, LookupItemType } from '../models'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from './TextField'

export type LookupItemPickerUserPropsType = {
  name?: string // input name
  label: string
  selectedItemCode: string | null
  onValueChanged: (code: string | null, value?: LookupItemType | null) => void
  helperText: React.ReactNode
  error: boolean
  required?: boolean
  onBlur?: (e: React.FocusEvent<any>) => void
}
type LookupItemPickerPropsType = LookupItemPickerUserPropsType & {
  lookupItems: LookupItemType[]
}

export const LookupItemPicker = (pickerProps: LookupItemPickerPropsType) => {
  // Get selected item
  const selectedLookupItem: LookupItemType | null = getLookupItemByCodeOrNew(
    pickerProps.lookupItems,
    pickerProps.selectedItemCode
  )
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const lbl = pickerProps.label // to make a breakpoint here...

  // 'inputValueText' - localized name of the Lookupable
  const [inputValueText, setInputValueText] = useState<string>(
    selectedLookupItem?.name ?? ''
  )
  // 'inputValueText' is updated whenever selectedDestinationItem changes
  useEffect(() => {
    setInputValueText(selectedLookupItem?.name ?? '')
  }, [selectedLookupItem])

  // Update 'inputValueText' whenever text in the inputField changes
  function onInputWritten(event: React.ChangeEvent<HTMLInputElement>): void {
    setInputValueText(event.target.value)
  }

  // Update 'inputValueText' whenever text in the inputField changes
  function onAutocompleteInputChanged(event: any, newInputValue: any): void {
    setInputValueText(newInputValue)
  }

  // Value selected from the dropdown: Fire destinationSelected event.
  function onAutocompleteChanged(
    event: any,
    value: LookupItemType | null
  ): void {
    if (pickerProps.onValueChanged) {
      pickerProps.onValueChanged(value?.code ?? null, value ?? null)
    }
  }

  function onInputBlur(e: React.FocusEvent<any>): void {
    if (pickerProps.onBlur) {
      pickerProps.onBlur(e)
    }
  }

  return (
    <Autocomplete
      value={selectedLookupItem}
      options={pickerProps.lookupItems}
      getOptionLabel={(option) => option.name}
      inputValue={inputValueText}
      getOptionSelected={(option, value) => option.code === value.code}
      onChange={onAutocompleteChanged}
      onInputChange={onAutocompleteInputChanged}
      autoSelect={true}
      autoHighlight={true}
      renderInput={(textFieldProps) => (
        <TextField
          {...textFieldProps}
          // @ts-ignore // 'name' lze nastavit a resi problem s identifikaci pole z formiku pri onBlur (<input bude mit name={name}>)
          //            // nicmene 'name' neni v popisu atributu TextFieldProps... zvlastni...
          name={pickerProps.name}
          label={pickerProps.label}
          InputProps={{
            ...textFieldProps.InputProps,
            required: false,
          }}
          required={pickerProps.required}
          helperText={pickerProps.helperText}
          error={pickerProps.error}
          onChange={onInputWritten}
          onBlur={onInputBlur}
        />
      )}
    />
  )
}
